import type { Ref } from 'react'
import type { FormStepConfig } from '@/configs/docs-form'
import type { DocsFormValues } from '@/helpers/docs-form'
import { SectionCard } from './SectionCard'

const fieldClassName =
  'w-full rounded-[22px] bg-[var(--app-input)] px-4 py-3 text-sm leading-6 text-[var(--app-text)] outline-none transition placeholder:text-[var(--app-hint)] focus:border-[var(--app-accent)] focus:ring-4 focus:ring-[var(--app-accent-soft)]'

type DocsFormStepSectionsProps = {
  sections: readonly FormStepConfig[]
  values: DocsFormValues
  maskedRefs: Partial<Record<keyof DocsFormValues, Ref<HTMLInputElement>>>
  onValueChange: (key: keyof DocsFormValues, value: string) => void
}

export const DocsFormStepSections = ({
  sections,
  values,
  maskedRefs,
  onValueChange,
}: DocsFormStepSectionsProps) =>
  sections.map((section) => (
    <SectionCard
      key={section.title}
      title={section.title}
      description={section.description}
    >
      {section.fields.map((field) => {
        const inputId = `field-${field.key}`

        return (
          <div key={field.key} className="space-y-2">
            <label
              className="block text-sm font-medium text-[var(--app-text)]"
              htmlFor={inputId}
            >
              {field.label}
            </label>

            {field.multiline ? (
              <textarea
                className={`${fieldClassName} min-h-28 resize-y`}
                id={inputId}
                value={values[field.key]}
                onChange={(event) =>
                  onValueChange(field.key, event.target.value)
                }
                placeholder={field.placeholder}
                rows={3}
              />
            ) : field.options ? (
              <div className="relative">
                <select
                  className={`${fieldClassName} appearance-none pr-12`}
                  id={inputId}
                  value={values[field.key]}
                  onChange={(event) =>
                    onValueChange(field.key, event.target.value)
                  }
                >
                  <option value="">Выберите значение</option>
                  {field.options.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-[var(--app-muted)]">
                  ↓
                </span>
              </div>
            ) : (
              <input
                className={fieldClassName}
                id={inputId}
                value={values[field.key]}
                onChange={(event) =>
                  onValueChange(field.key, event.target.value)
                }
                placeholder={field.placeholder}
                ref={maskedRefs[field.key]}
                inputMode={field.inputMode}
              />
            )}
          </div>
        )
      })}
    </SectionCard>
  ))
